import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@emotion/react';
import { CssBaseline } from '@mui/material';
import React from 'react';
import { theme } from './styles/theme';
import { App } from './App';
import './i18n';
import { GlobalSnackbar } from './components/snackbar/GlobalSnackbar';
import { ErrorBoundary } from './components/errorBoundary/ErrorBoundary';

if (import.meta.env.MODE !== 'development') {
  console.log = () => {};
  console.warn = () => {};
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <GlobalSnackbar />
      <CssBaseline />
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </ThemeProvider>
  </React.StrictMode>
);
